export default __webpack_public_path__ + "static/media/thaigot-screenshot-03.7678329c.png";